import React, { FunctionComponent, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useUserSessionStore } from "stores/v2/userSessionStore";
import { useAcademyMFEContextStore } from "stores/v2/academyMFEContextStore";
import shallow from "zustand/shallow";
import { getClasswizeTenantKey } from "stores/classwizeConfigStore";

export const LoginRouteWrapper: FunctionComponent = () => {
	const userSessionStore = useUserSessionStore((state) => ({ logout: state.logout, clearSession: state.clearSession }), shallow);
	const navigate = useNavigate();

	useEffect(() => {
		// Clear auth info whenever any login routes are visited
		userSessionStore.logout().catch((e) => {
			// This will only work if the user is already logged in and their token is valid.
			// But we should still call it anyway to invalidate the token on the server if possible.
			console.error("Failed to logout", e);
		});
		userSessionStore.clearSession();

		// Set Masquerade to false on login
		useUserSessionStore.getState().setMasquerade(false);

		// Initialize training params from URL after clearing session
		useAcademyMFEContextStore.getState().parseAndSetTrainingParams(window.location.href);

		const tenantKey = getClasswizeTenantKey();

		// Redirect to tenant-specific login page if tenant key is available
		if (tenantKey) {
			navigate(`/login/${tenantKey}`, { replace: true });
		}
	}, [userSessionStore, navigate]);

	return <Outlet />;
};
